import {Injectable} from "@angular/core";
import {ServerService} from "./ServerService";
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class EstoqueService extends ServerService {

  public listeGrupos(inicio = 0, total = 50){
    return this.obtenha('/estoque/grupos', { i: inicio, t: total})
  }

  public listeInsumos(inicio = 0, total = 50, qs: any = { }){
    let params: any = { i: inicio, t: total};

    Object.keys(qs).forEach((key) => {
      params[key] = qs[key]
    })
    return this.obtenha('/estoque/insumos', params)
  }

  public importeInsumosCsv(arquivo: File, opcoes: any){
    return this.upload('/estoque/insumos/importar/csv', arquivo, opcoes)
  }

  public exporteInsumosCsv(ids: number[]): Promise<Blob>{
    return this.http.post('/estoque/insumos/exportar/csv', {ids}, {responseType: 'blob'})
      .toPromise().catch(this.handleError)
  }

  public listeAlertasMinimo( filtro: any = {}){
    return this.obtenha('/estoque/insumos/alerta/minino', filtro)
  }

  listeAlertasMinimoProdutos(filtro: any = {}) {
    return this.obtenha('/estoque/produtos/alerta/minino', filtro)
  }

  public listeUnidades(inicio = 0, total = 50){
    return this.obtenha('/estoque/unidades', { i: inicio, t: total})
  }

  public listeTiposEmbalagem(){
    return this.obtenha('/estoque/tipos-embalagem', {})
  }

  public listeApresentacoesCompra(insumoId: number){
    return this.obtenha(`/estoque/insumos/${insumoId}/apresentacoes`, {})
  }

  public listeApresentacoesCompraGlobais(filtro: any = {}){
    return this.obtenha('/estoque/apresentacoes-compra', filtro)
  }

  public salveApresentacaoCompraGlobal(apresentacao: any){
    const payload = {
      unidadeBase: apresentacao.unidadeBase ? {id: apresentacao.unidadeBase.id} : null,
      tipoEmbalagem: apresentacao.tipoEmbalagem ? {id: apresentacao.tipoEmbalagem.id} : null,
      descricao: apresentacao.descricao,
      fatorConversao: apresentacao.fatorConversao,
      ativa: apresentacao.ativa
    };
    return apresentacao.id
      ? this.facaPut(`/estoque/apresentacoes-compra/${apresentacao.id}`, payload)
      : this.facaPost('/estoque/apresentacoes-compra', payload)
  }

  public removaApresentacaoCompraGlobal(id: number){
    return this.remova(`/estoque/apresentacoes-compra/${id}`, {})
  }

  public listeInsumosCandidatosApresentacao(apresentacaoId: number, filtro: any = {}){
    return this.obtenha(
      `/estoque/apresentacoes-compra/${apresentacaoId}/insumos-candidatos`,
      filtro
    )
  }

  public listeVinculosDaApresentacao(apresentacaoId: number){
    return this.obtenha(`/estoque/apresentacoes-compra/${apresentacaoId}/vinculos`, {})
  }

  public vinculeApresentacaoEmLote(
    apresentacaoId: number,
    insumoIds: number[],
    definirComoPadrao = false
  ){
    return this.facaPost(`/estoque/apresentacoes-compra/${apresentacaoId}/vinculos`, {
      insumoIds,
      definirComoPadrao
    })
  }

  public salveApresentacaoCompra(insumoId: number, apresentacao: any){
    const payload: any = {
      codigoFornecedor: apresentacao.codigoFornecedor,
      padrao: apresentacao.padrao,
      ativa: apresentacao.ativa
    };
    if(!apresentacao.id)
      payload.apresentacaoCompraId = apresentacao.apresentacaoCompra &&
        apresentacao.apresentacaoCompra.id;
    return apresentacao.id
      ? this.facaPut(`/estoque/insumos/${insumoId}/apresentacoes/${apresentacao.id}`, payload)
      : this.facaPost(`/estoque/insumos/${insumoId}/apresentacoes`, payload)
  }

  public removaVinculoApresentacaoCompra(insumoId: number, vinculoId: number){
    return this.remova(`/estoque/insumos/${insumoId}/apresentacoes/${vinculoId}`, {})
  }

  public obtenhaCatalogoComprasInternas(){
    return this.obtenha('/estoque/compras-internas/catalogo', {})
  }

  public listeProdutosFabricaCompraInterna(){
    return this.obtenha('/estoque/compras-internas/produtos-fabrica', {})
  }

  public listeProdutosSugeridosFornecimento(apresentacaoInsumoId: number, texto?: string){
    const filtro: any = {};
    if(texto !== undefined)
      filtro.texto = texto;
    return this.obtenha(
      `/estoque/compras-internas/apresentacoes-insumo/${apresentacaoInsumoId}/produtos-sugeridos`,
      filtro
    )
  }

  public crieVinculoFornecimentoItem(vinculo: any){
    return this.facaPost('/estoque/compras-internas/vinculos', vinculo)
  }

  public atualizeVinculoFornecimentoItem(id: number, vinculo: any){
    return this.facaPut(`/estoque/compras-internas/vinculos/${id}`, vinculo)
  }

  public crieCompraInterna(compra: any){
    return this.facaPost('/estoque/compras-internas/pedidos', compra)
  }

  public listeComprasInternas(filtro: any = {}){
    return this.obtenha('/estoque/compras-internas/pedidos', filtro)
  }

  public obtenhaCompraInterna(id: number){
    return this.obtenha(`/estoque/compras-internas/pedidos/${id}`, {})
  }

  public canceleCompraInterna(id: number, motivo: string = null){
    return this.facaPost(`/estoque/compras-internas/pedidos/${id}/cancelar`, {motivo})
  }

  public recebaCompraInterna(id: number){
    return this.facaPost(`/estoque/compras-internas/pedidos/${id}/receber`, {})
  }

  public listeMotivosMotimentacoes( ){
    let params: any = {};


    return this.obtenha('/estoque/movimentacoes/motivos', params)
  }


  public listeMovimentacoes(inicio = 0, total = 25, dataInicio: number, dataFim: number,
                            termo: string = null, grupo: any = null) {
    let params: any = { i: inicio, t: total};

    if(dataInicio) params.di = moment(dataInicio).format('YYYYMMDD');
    if(dataFim) params.df = moment(dataFim).format('YYYYMMDD');
    if(termo) params.termo = termo;
    if(grupo) params.gid = grupo.id;

    return this.obtenha(`/estoque/movimentacoes`, params)
  }

  public listeMovimentacoesInsumo(insumo: any, inicio = 0, total = 25, filtro: any = {}) {
    return this.obtenha(
      `/estoque/insumos/${insumo.id}/movimentacoes`,
      this.monteFiltroMovimentacoes(inicio, total, filtro)
    )
  }

  public listeMovimentacoesProduto(produto: any, inicio = 0, total = 25, filtro: any = {}) {
    return this.obtenha(
      `/estoque/produtos/${produto.id}/movimentacoes`,
      this.monteFiltroMovimentacoes(inicio, total, filtro)
    )
  }

  obtenhaStatusControleCustoEstoque() {
    return this.obtenha('/estoque/custos/status', {});
  }

  listeRelatorioPosicaoEstoque(filtro: any = {}) {
    return this.obtenha('/estoque/custos/relatorios/posicao', filtro);
  }

  listeRelatorioMovimentacoesValorizadas(filtro: any = {}) {
    return this.obtenha('/estoque/custos/relatorios/movimentacoes', filtro);
  }

  listeEvolucaoCustoMedio(filtro: any = {}) {
    return this.obtenha('/estoque/custos/relatorios/evolucao', filtro);
  }

  listeInconsistenciasFinanceiras() {
    return this.obtenha('/estoque/custos/relatorios/inconsistencias', {});
  }

  salveGrupo(grupo: any) {
    return this.salve('/estoque/grupo', grupo)
  }

  salveInsumo(insumo: any) {
    return this.salve('/estoque/insumos', insumo)
  }

  gereProdutoDeInsumo(insumoId: number, produto: any) {
    return this.facaPost(`/estoque/insumos/${insumoId}/gerar-produto`, produto)
  }

  removaInsumo(insumo: any){
    return this.facaPut(`/estoque/insumos/${insumo.id}/remova`, insumo)
  }


  removaGrupo(grupo: any){
    return this.facaPut(`/estoque/grupo/${grupo.id}/remova`, grupo)
  }

  vinculeProdutosNoInsumo(insumo: any, produtos: any[]) {
    return this.facaPost(String(`/estoque/insumos/${insumo.id}/produtos/add`), {insumo: insumo, produtos: produtos});
  }

  async removaVinculoProduto(insumo: any, produtoAssociado: any) {
    return this.facaPost(String(`/estoque/insumos/${insumo.id}/produtos/del`), {insumo: insumo, produto: produtoAssociado});
  }


  vinculeOpcoesNoInsumo(insumo: any, opcoes: number[]) {
    return this.facaPost(String(`/estoque/insumos/${insumo.id}/opcoes/add`), {insumo: insumo, opcoes: opcoes});
  }

  async removaVinculoOpcao(insumo: any, opcao: any) {
    return this.facaPost(String(`/estoque/insumos/${insumo.id}/opcoes/del`), {insumo: insumo, opcao: opcao});
  }

  registreMovimentacaoManual(novaMovimentacao: any) {
    return this.facaPost(String(`/estoque/movimentacoes/manual/insumos/${novaMovimentacao.insumo.id}`),
      novaMovimentacao);
  }


  registreMovimentacoesManual(novaMovimentacao: any) {
    return this.facaPost(String(`/estoque/movimentacoes/manual`),
      novaMovimentacao);
  }

  prevejaBeneficiamento(insumos: any[]) {
    return this.facaPost('/estoque/movimentacoes/beneficiamento/previa', {insumos});
  }

  obtenhaBeneficiamento(id: number) {
    return this.obtenha(`/estoque/beneficiamentos/${id}`, {});
  }

  estorneBeneficiamento(id: number, justificativa: string) {
    return this.facaPost(`/estoque/beneficiamentos/${id}/estorno`, {justificativa});
  }


  async listeComposicaoDo(insumo: any) {
      return this.obtenha(`/estoque/insumos/${insumo.id}/composicoes`, {});
  }

  listeHistoricoInsumo(insumo: any, filtro: any = null) {
    let parametros = []
    if(filtro) {


      if(filtro.texto) parametros.push('texto=' + filtro.texto)
      if(filtro.operacao) parametros.push('operacao=' + filtro.operacao.id)
      if(filtro.t) {
        parametros.push('i=' + (filtro.i ? filtro.i : '0'))
        parametros.push('t=' + filtro.t)
      }


    }

    return this.obtenha(`/estoque/insumos/${insumo.id}/historico`, parametros );
  }

  private monteFiltroMovimentacoes(inicio: number, total: number, filtro: any): any {
    const parametros: any = {i: inicio, t: total};
    if(filtro.inicio) parametros.di = moment(filtro.inicio).format('YYYYMMDD');
    if(filtro.fim) parametros.df = moment(filtro.fim).format('YYYYMMDD');
    if(filtro.status) parametros.status = filtro.status;
    return parametros;
  }


}
